import { useRef } from "react";
import { Minus, Plus } from "lucide-react";

export function Dial({ value, onChange, max = 12, min = 1, label, testId = "dial" }) {
  const ref = useRef(null);
  const R = 92, C = 120;
  const angle = max > 0 ? ((value || 0) / max) * 2 * Math.PI : 0;
  const end = { x: C + R * Math.sin(angle), y: C - R * Math.cos(angle) };
  const arc = value >= max ? `M ${C} ${C - R} A ${R} ${R} 0 1 1 ${C - 0.01} ${C - R}` : `M ${C} ${C - R} A ${R} ${R} 0 ${angle > Math.PI ? 1 : 0} 1 ${end.x} ${end.y}`;
  const pick = (e) => {
    const b = ref.current.getBoundingClientRect();
    const x = e.clientX - b.left - b.width / 2, y = e.clientY - b.top - b.height / 2;
    let a = Math.atan2(x, -y); if (a < 0) a += 2 * Math.PI;
    onChange(Math.min(max, Math.max(min, Math.round((a / (2 * Math.PI)) * max) || max)));
  };
  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <svg ref={ref} viewBox="0 0 240 240" className="h-56 w-56 cursor-pointer touch-none select-none" onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); pick(e); }} onPointerMove={(e) => e.buttons === 1 && pick(e)}>
        <defs><filter id="dialShadow" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#000" floodOpacity="0.12" /></filter></defs>
        <circle cx={C} cy={C} r={R + 18} fill="var(--gray-6)" filter="url(#dialShadow)" />
        <circle cx={C} cy={C} r={R} fill="none" stroke="var(--gray-5)" strokeWidth="26" />
        <path d={arc} fill="none" stroke="var(--tint)" strokeWidth="26" strokeLinecap="round" />
        {Array.from({ length: max }).map((_, i) => { const a = (i / max) * 2 * Math.PI; return <circle key={i} cx={C + (R + 30) * Math.sin(a)} cy={C - (R + 30) * Math.cos(a)} r="2" fill="var(--label-3)" />; })}
        <circle cx={C} cy={C} r={R - 24} fill="#FFFFFF" filter="url(#dialShadow)" />
        <circle cx={end.x} cy={end.y} r="13" fill="#FFFFFF" filter="url(#dialShadow)" stroke="var(--gray-5)" />
        <text x={C} y={C + 8} textAnchor="middle" className="fill-foreground" style={{ fontSize: label.big.length > 5 ? 30 : 46, fontWeight: 700, letterSpacing: -1.5 }}>{label.big}</text>
        <text x={C} y={C + 32} textAnchor="middle" className="fill-foreground" style={{ fontSize: 14, fontWeight: 600 }}>{label.small}</text>
      </svg>
      <div className="mt-2 flex items-center gap-3">
        <button type="button" onClick={() => onChange(Math.max(min, value - 1))} className="grid h-9 w-9 place-items-center rounded-full border border-separator" aria-label="Less" data-testid={`${testId}-minus`}><Minus className="h-4 w-4" /></button>
        <span className="text-sm text-label2">{label.hint}</span>
        <button type="button" onClick={() => onChange(Math.min(max, value + 1))} className="grid h-9 w-9 place-items-center rounded-full border border-separator" aria-label="More" data-testid={`${testId}-plus`}><Plus className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
